import { render } from "./CrowdGood.vue?vue&type=template&id=dcc2fabe&scoped=true"
import script from "./CrowdGood.vue?vue&type=script&lang=js"
export * from "./CrowdGood.vue?vue&type=script&lang=js"

import "./CrowdGood.vue?vue&type=style&index=0&id=dcc2fabe&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc2fabe"]])

export default __exports__